import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { FC, useEffect, useMemo } from 'react';
import Text from '~/components/Text';
import Colors from '~/constants/colors';
import { trackingOnProductClick } from '~/services/tracking';
import styles from './OrderProductItem.module.scss';
import { OrderItem } from '~/data/user/interfaces';
import { PATH } from '~/constants/enum';
import { useLazyQuery } from '@apollo/client';
import { QUERY_GET_ACTUAL_PRODUCT } from '~/data/home';
import { QUERY_GET_PRODUCT_ORDER } from '~/data/user';

interface OrderProductItemProps {
    orderItem: OrderItem;
    className?: string;
}

const OrderProductItem: FC<OrderProductItemProps> = ({ orderItem, className }) => {
    const [queryActual, { data: actualData, loading }] = useLazyQuery<any>(QUERY_GET_PRODUCT_ORDER, {
        nextFetchPolicy: 'no-cache',
        onError: ({ message }) => {
            console.error(message, `QUERY_GET_ACTUAL_PRODUCT`);
        },
        context: { fetchOptions: { method: 'GET' } }
    });

    useEffect(() => {
        queryActual({
            variables: {
                url_key: [orderItem.product_url_key]
            }
        });
    }, []);

    const product = useMemo(() => {
        const actualProduct = actualData?.products?.items?.[0];
        const selectedVariant = actualProduct?.variants?.find(
            (variant: any) => variant?.product?.sku === orderItem?.product_sku
        );
        return {
            ...(actualProduct || {}),
            ...orderItem,
            selectedVariant
        };
    }, [actualData, orderItem]);

    return (
        <Link
            href={{
                pathname: PATH.ProductDetail,
                query: {
                    slug: orderItem?.product_url_key,
                    variant: product?.selectedVariant?.product?.id
                }
            }}
            onClick={() => {
                // trackingOnProductClick(orderItem?.variant);
            }}
        >
            <div className={classNames(styles.order_product_item, className)}>
                <div className={styles.left}>
                    <img
                        src={product?.thumbnail?.url}
                        alt={product?.thumbnail?.url}
                        width={68}
                        height={68}
                        className="rounded object-cover"
                    />
                </div>
                <div className={styles.right}>
                    <Text type="title-5" color={Colors.GREY_900} className="line-clamp-2">
                        {product.product_name}
                    </Text>
                    <Text type="body-3" color={Colors.GREY_700} className="mt-1 mb-2 capitalize">
                        {product?.selectedVariant?.attributes?.map((attr: any) => attr.label)?.join(' / ')}
                    </Text>
                    <div className="flex items-center justify-between gap-4">
                        <Text type="body-3" color={Colors.GREY_800}>
                            x{product.quantity_ordered}
                        </Text>
                        <Text type="title-5" color={Colors.PRIMARY}>
                            ${product?.product_sale_price?.value?.toFixed(2)}
                        </Text>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default OrderProductItem;
